import { defineStore } from 'pinia'
import moment from "moment";

export const CurrentPeriod = defineStore('sch_c_period', {
    state: () => {
        return { sch_c_period: moment().set({'date': 1, 'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0}) }
    },
    actions: {
        get() {
            return this.sch_c_period
        },
        set(data) {
            this.sch_c_period = data
        }
    },
})

export const PeriodSize = defineStore('sch_period_size', {
    state: () => {
        return { sch_period_size: 3 }
    },
    actions: {
        get() {
            return this.sch_period_size
        },
        set(data) {
            this.sch_period_size = data
        }
    },
})